import * as React from 'react';

function SvgSSubmit(props) {
  return (
    <svg viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="#FCCE01" d="M3.293 3.935h9.882v11.118H3.293z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.29 1.781c.376 0 .683.34.683.76v3.94c0 .279.23.504.513.504a.508.508 0 00.513-.504v-4.32c0-.84-.612-1.52-1.368-1.52H1.366C.61.64 0 1.32 0 2.16v11.783c0 .84.611 1.52 1.367 1.52H6.06c.153 0 .3-.06.408-.167a.563.563 0 00.169-.402.579.579 0 00-.584-.571H1.708c-.378 0-.684-.34-.684-.76V2.54c0-.42.307-.76.684-.76H12.29zM9.546 3.823H2.885a.64.64 0 00-.646.636v.1c0 .351.289.636.646.636h6.66a.652.652 0 00.457-.186.63.63 0 00.19-.45v-.101a.63.63 0 00-.19-.45.652.652 0 00-.457-.185zM2.934 6.476h3.378a.69.69 0 01.695.684v.002a.69.69 0 01-.695.685H2.934a.702.702 0 01-.492-.2.678.678 0 01-.203-.485V7.16a.69.69 0 01.695-.684zm1.137 2.652H2.775a.69.69 0 00-.696.684v.003c0 .181.073.355.204.484.13.128.307.2.492.2H4.07a.691.691 0 00.696-.684v-.003a.69.69 0 00-.696-.684zm9.734-.328a.634.634 0 010 .907.666.666 0 01-.926 0l-1.066-1.041v4.307c0 .17-.07.334-.193.454a.659.659 0 01-.462.188.65.65 0 01-.656-.642V8.667l-1.063 1.04a.666.666 0 01-.927 0 .634.634 0 010-.907l2.183-2.135a.66.66 0 01.926 0L13.805 8.8zm-.386 5.525H8.9c-.32 0-.579.255-.579.57 0 .314.26.57.58.57h4.52c.32 0 .579-.256.579-.57 0-.315-.26-.57-.58-.57z"
        fill="#595959"
      />
    </svg>
  );
}

export default SvgSSubmit;
